import { Filters, Value } from "PFTypes";

import { FiltersData } from "../contexts/marketplace_context.types";
import { StartDateCondition } from "../hooks/use_start_date_filter";

export const getMatchingActivitiesFilters = (
  filtersData: FiltersData,
  isUnreadOnly: boolean,
  startDate?: StartDateCondition | null
): Filters<Value> => ({
  ...filtersData,
  fields: {
    ...filtersData?.fields,
    ...(isUnreadOnly ? { readStatus: false } : {}),
    ...(startDate
      ? {
          start_date: {
            end: startDate.to,
            start: startDate.from
          }
        }
      : {})
  }
});
